export * from './lib/shared-feature-ngx-translate.module';
